import styled from 'styled-components';
import { FullWidth } from 'ui/utility/fullWidth';
import { PageHeader } from 'ui/pageHeader';
import { colors, spacing } from 'ui/theme';
import { normalPageMaxWidth } from 'ui/theme/spacing';

/**
 * Generic container for layout of internal components
 * Wrap this in a styled component if a background-color is needed
 */
export const Container = styled.section`
  display: block;
  width: 100%;
  max-width: ${normalPageMaxWidth};
  padding-right: ${spacing.base};
  padding-left: ${spacing.base};
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 768px) {
    padding-right: ${spacing.double};
    padding-left: ${spacing.double};
  }
`;

export const PageHeaderWrapper = styled(FullWidth)`
  border-bottom: ${spacing.single} solid ${colors.grey15};
`;

export const PageContentsWrapper = styled(FullWidth)`
  padding-top: ${spacing.x3};
  padding-bottom: ${spacing.x3};
  background-color: ${colors.grey1};
`;

export const PageMainHeader = styled(PageHeader)`
  margin-top: ${spacing.x3};
  margin-bottom: ${spacing.x4};
`;
